module.exports = __webpack_public_path__ + "img/p-left.4824a74f.svg";